import { API } from '../src/Constant'

export const ENDPOINTS = {
    USER_DETAILS: API + "/admin/grid",
    ACCOUNT_CLOSURE: API + "/admin/account-closure",
    HOME_VALUATION: API + "/admin/home-valuation-update",
    PROMO_CODES: API + "/admin/promocode-records",
    GIFTCARD_DASBOARD: API + "/admin/gift-card-dashboard",
    EQUIFAX_ADDRESS: API + "/admin/equifax-address",
    READ_CREDIT_REPORT: API + "/admin/read-credit-report",
    WITHDRAW_USER_AMOUNT: API + "/admin/withdraw-user-amount",
    TRANSFER_AMOUNT_TO_USER_WALLET: API + "/admin/transfer-amount-to-user-wallet",
    REFUND_AMOUNT_TO_USER_ACCOUNT: API + "/admin/refund-amount-to-user-account",
    USER_REMORTGAGE: API + "/admin/user-remortgage",
    USER_ACTIVITY: API + "/admin/user-account-activity",
    USER_LIVE_EWALLET_HISTORY_FETCH: API + "/admin/user_live_ewallet_history_fetch",
    TRANSFER_REWARD_AMOUNT: API + "/admin/transfer-reward-amount",
    REDIS_CACHE_CLEANER: API + "/admin/redis-cache-clean",
    ADD_PROMOCODE: API + "/admin/add-promocode",
    ADD_REFERRAL: API + "/admin/add-referral",
    UPDATE_PAY_TO_LENDER: API + "/admin/update-pay-to-lender",
    UPDATE_PENDING_TASK: API + "/admin/update-pending-task",
    UPDATE_USER_PENDING_ACTION: API + "/admin/update-user-pending-action",
    VERIFICATION_LINK: API  + "/admin/verification-link",
    PPS_PAYEE: API + "/admin/pps-payee",
    DELETE_USER: API + "/admin/delete-user",
    MANAGE_USER: API + "/admin/manage-user",
    PN_NOTIFIER: API + "/admin/pn-notifier",
    MASTER_TO_USER_EWALLET_FAILURE: API + "/admin/master-to-user-ewallet-failure",
    AML_VERIFICTION_PPS: API + "/admin/aml-verification-pps",
    TOGGLE_DIRECT_DEBIT: API + "/admin/toggle-direct-debit",
    UPDATE_GIFT_CARD_BLACKLIST: API + "/admin/update-gift-card-blacklist",
    REMORTGAGE_LETTER: API + "/admin/remortgage-letter",
    GENERATE_BROKER_REPORT: API + "/admin/generate-broker-report",
    ADD_AFFILIATES_REWARDS: API + "/admin/add-affiliates-reward",
    CANCEL_GIFT_CARD: API + "/admin/cancel-gift-card",  
    REMOVE_USER_FROM_SUPPRESSION_LIST: API + "/admin/remove-user-from-suppression-list",
    REMOVE_PIN_FOR_USER: API + "/admin/remove-pin-for-user",
    FORCE_LOGOUT_USER: API + "/admin/force-logout-user",
    USER_MORTGAGE_DATA: API + "/admin/user-mortgage-data",
    RESET_CREDIT_REPORT_PULL_ATTEMPTS: API + "/admin/reset-credit-report-pull-attempts",
    CHANGE_GIFT_CARD_STATE: API + "/admin/change-giftcard-state",
    CREATE_PROMOCODE: API + "/admin/create-promocode",
    RESTORE_USER_ACCOUNT: API + "/admin/restore-user-account",
    TRUELAYER_SYNC_FAILURE_MONITOR: API + "/admin/truelayer-sync-account-failure-monitor",
    DUPE_ACCOUNT_CHECK: API + "/admin/dupe-account-check",
    DELETE_VRP_CONSENT: API + "/admin/delete-vrp-consent",
    SUPERCHARGED_CALCULATER: API + "/admin/calculate-supercharged-rate",
    GIFT_CARD_DETAILS_PAGE: API + "/admin/gift-card-details-page",
    VDX_DASHBOARD_DETAILS: API + "/admin/vdx-dashboard-details",
    FEATURE_FLAG_DASHBOARD: API + "/admin/feature-flag-dashboard",
    UPDATE_USER: API + "/admin/update-user",
    MOVE_ACCOUNT_REWARDS: API + "/admin/rewards/move-to-another-account",
    REMOVE_BIOMETRIC_FOR_USER: API + "/admin/remove-biometric-for-user",
    MANAGE_USER_PASSKEYS: API + "/admin/manage-user-passkeys",
    MANAGE_DEVICE_SIGNATURES: API + "/admin/manage-device-signatures",
    MASTER_TO_USER_EWALLET_DASHBOARD: API + "/admin/master-to-user-ewallet-dashboard",
    TRANSFER_MASTER_TO_REWARDS: API + "/admin/transfer-master-wallet-amount-to-rewards-wallet",
    TRANSFER_REWARDS_TO_MASTER: API + "/admin/transfer-rewards-wallet-amount-to-master-wallet",
    UPDATE_MASTER_TO_USER_EWALLET_FAILURE: API + "/admin/master-to-user-ewallet-dashboard",
    CHECK_MASTER_BALANCE: API + "/admin/master-to-user-ewallet-dashboard",
}
export default ENDPOINTS;
